export interface IUnifiedTrackingResponse<T> {
  result: 'OK' | 'ERROR';
  friendlyDescription?: string;
  data: T;
  context: {
    clientRequestId: string;
    serverRequestId: string;
  };
}

export interface IUnifiedTrackingRequest<T> {
  route: string;
  id: string;
  orgId: string;
  data: T;
}

export interface IAuthUnifiedTrackingRequest {
  token: string;
}

export interface IConfigUnifiedTrackingRequest {
  tenantId: string;
}

export interface IAuthUnifiedTrackingResponse {
  id: IAuthUnifiedTrackingResponseType;
  reason?: string;
}

export interface IOrgUnifiedTrackingResponse {
  id: string;
  tenantIds: string[];
}

export interface IConfigUnifiedTrackingResponse {
  id: string;
  dataFlows: DataFlow[];
  tenant: {
    contextIds: string[];
    id: string;
  };
}

export interface ISiteUnifiedTracking {
  id: string;
  enabled: boolean;
  pos: { [key: string]: { [key: string]: string[] } };
}

export interface IDestinationUnifiedTracking {
  id: string;
  trigger?: any;
  clientKey?: string;
  secrets?: {
    apiKey: string;
    accountId: string;
    domainId: string;
  };
}

export interface DataFlow {
  friendlyName: string;
  sites: ISiteUnifiedTracking[];
  destinations: Array<DestinationCdpp | DestinationSearch | Destination>;
}

export interface Destination {
  id: string;
  clientKey?: string;
  secrets?: Secrets;
}

export interface DestinationCdpp {
  id: 'cdpp';
  clientKey: string;
}

export interface DestinationSearch {
  id: 'search';
  secrets: Secrets;
}

export interface Secrets {
  apiKey: string;
  accountId: string;
  domainId: string;
}

export enum IAuthUnifiedTrackingResponseType {
  connectionAuthorized = 'ConnectionAuthorized',
  connectionAlreadyAuthorized = 'ConnectionAlreadyAuthorized',
  connectionAuthorizationDenied = 'ConnectionAuthorizationDenied',
}
